// extracted by mini-css-extract-plugin
export default {"root":"_1Moic","image":"_1SofO","large":"_2kG1f","medium":"_3qFxs","small":"_3IFc8"};